import classNames from 'classnames';
import { useEffect } from 'react';
import { useChallengeScore } from '~/components/Challenge/Score/ChallengeScore.hooks';
import { ChallengeScoreUpFormik } from '~/components/Challenge/Score/Form/ChallengeScoreUpFormik';
import { QueryErrorBoundary } from '~/components/Error';
import { T } from '~/components/I18n';
import { BottomSheet, BottomSheetProps } from '~/components/Modal/BottomSheet';
import styles from './ChallengeScoreUpBottomSheet.module.scss';

export type ChallengeScoreUpBottomSheetProps = BottomSheetProps;
export const ChallengeScoreUpBottomSheet = ({
  className,
  onConfirm,
  onDismiss,
  ...props
}: ChallengeScoreUpBottomSheetProps) => {
  const {
    isFetched,
    data: { week = 0 },
  } = useChallengeScore();

  useEffect(() => {
    // TODO: impression event might need to be updated with dosi-analytics npm interface
    gtag('event', 'impression_challenge_score_up_bottomsheet');
  }, []);

  return (
    <BottomSheet
      {...props}
      className={classNames(styles.root, className)}
      title={<T className={styles.title} name="citizen_challenge_scoreup_name" />}
      description={
        <T
          className={styles.description}
          name="citizen_challenge_scoreup_popup_desc1"
          options={[isFetched ? week : '-']}
        />
      }
      onConfirm={onConfirm}
      onDismiss={onDismiss}>
      {({ confirm, dismiss }) => (
        <QueryErrorBoundary onReset={dismiss}>
          <ChallengeScoreUpFormik onSubmit={confirm} />
        </QueryErrorBoundary>
      )}
    </BottomSheet>
  );
};
